module.exports = __webpack_public_path__ + "img/36vsGC.1f660ac9.png";